export default __webpack_public_path__ + "static/subtle_grunge-d67413731b8c202a6294fe17f3d5a616.png";